import "../../stylesheets2025/registration.css";
import ScrollToTop from "../../components2025/ScrollToTop";

const Registration = () => {
    return (
        <div className="containAll flex flex-col justify-center items-center">
            <ScrollToTop />

            {/* Page Heading */}
            <div className="heading">
                <h1>Registration</h1>
            </div>

            {/* Registration Forms Section */}
            <div className="form-container flex flex-col md:flex-row justify-center items-center gap-8 mt-10">
                {/* Author Form */}
                {/* <div className="form text-center">
                    <p>Author’s Registration Form</p>
                    <a
                        href="https://forms.gle/ArPdVFGjiNu3jCRE8"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Author’s Registration Form
                    </a>
                </div> */}

                {/* Attendee Form */}
                <div className="form text-center">
                    <p>Attendees Registration Form</p>
                    <a
                        href="https://forms.gle/esXbccnt3FieBUEw5"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Attendees Registration Form
                    </a>
                </div>


            </div>
            <div className="mb-20">
                <h4>Open to Students, Professionals, Researchers</h4>
            </div>

            {/* ---------- NEW CONTENT SECTION START ---------- */}

            {/* Major Submission Themes */}
            {/* <section className="themes-section">
                <h2>Major Submission Themes</h2>

                <div className="theme-block">
                    <h3>Energy</h3>
                    <ul>
                        <li>Renewable Energy Technologies</li>
                        <li>Energy-efficient Building Design</li>
                        <li>Self-Reliant Eco Systems</li>
                        <li>AI/ML Applications for Energy Optimisation</li>
                        <li>Traditional Use of Renewable Energy</li>
                        <li>Recycle Engineering (Energy Recovery & Resource Efficiency)</li>
                    </ul>
                </div>

                <div className="theme-block">
                    <h3>Water</h3>
                    <ul>
                        <li>Water Resource Development and Conservation</li>
                        <li>Integrated Water Management through Innovative Technologies</li>
                        <li>Climate-Resilient Water Systems for Rural Livelihoods</li>
                        <li>Water Conservation and Wastewater Management</li>
                        <li>Ancient water harvesting and Irrigation systems</li>
                        <li>Water Education, Awareness, and Community Empowerment</li>
                    </ul>
                </div>

                <div className="theme-block">
                    <h3>Ancient Knowledge Systems</h3>
                    <ul>
                        <li>Sustainability from an Indian Knowledge Systems Perspective</li>
                        <li>Sustainable Cultural Practices and Traditions</li>
                        <li>Women’s Role in Traditional Sustainable Societies</li>
                        <li>Science of Ancient Languages</li>
                        <li>AI/ML Applications for Sustainability (broader context)</li>
                        <li>Other Emerging Topics Related to Sustainability</li>
                    </ul>
                </div>
            </section> */}

            {/* Guidelines */}
            {/* <section className="guidelines-section">
                <h2>Guidelines for Paper Submission</h2>

                <ul>
                    <li>The digest should be written in Times New Roman, 12-point, single-line spacing.</li>
                    <li>Format: <strong>Abstract (250 words)</strong>, <strong>Methodology (max 500 words)</strong>, <strong>Results & Discussion (max 500 words)</strong>, <strong>Conclusion (100 words)</strong>, <strong>References</strong>.</li>
                    <li>Submit in PDF format only.</li>
                    <li>Abstract must be impersonal, clear, and informative.</li>
                    <li>Must include rationale, purpose, need, and significance.</li>
                    <li>Results & conclusions should highlight significance.</li>
                    <li>No commercial promotion or advertising.</li>
                    <li>Based on reviews, selected digests will be permitted for oral presentation; others will be assigned poster presentation.</li>
                    <li>All co-authors must approve the final submitted abstract.</li>
                </ul>

                <h3>The Four Cs of Digest Writing</h3>
                <ul>
                    <li><strong>Completeness:</strong> Covers all major research elements.</li>
                    <li><strong>Conciseness:</strong> No unnecessary information.</li>
                    <li><strong>Clarity:</strong> Easy to read; well-structured.</li>
                    <li><strong>Cohesiveness:</strong> Logical flow between sections.</li>
                </ul>
            </section> */}

            {/* Important Dates Table */}
            {/* <section className="dates-section">
                <h2>Important Dates</h2>

                <table className="dates-table">
                    <thead>
                        <tr>
                            <th>S. No</th>
                            <th>Details</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Last Date of Digest Submission</td>
                            <td>25 November 2025</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Acceptance Notification of the Digest</td>
                            <td>30 November 2025</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Submission of full-length papers (Max 4–6 pages)</td>
                            <td>07 December 2025</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Last Date of Registration for the Conference</td>
                            <td>09 December 2025</td>
                        </tr>
                    </tbody>
                </table>
            </section> */}

            {/* ---------- NEW CONTENT SECTION END ---------- */}
        </div>
    );
};

export default Registration;
